import { useMockKeycloak } from '@/contexts/MockKeycloakProvider'

/**
 * When SSO is disabled, this hook provides the mock Keycloak context
 * Components should import from this file instead of '@react-keycloak/web'
 */
export const useKeycloak = () => {
  return useMockKeycloak()
}
